"use strict";

window.addEventListener("DOMContentLoaded", function (event) {
  var mobileSearch = document.querySelector(".main-search-nav");
  if (mobileSearch != null) {
    var searchTriggerBtn = document.querySelector(".header__search");
    var closeSearch = document.querySelector(".main-search-nav__panel-close");
    var htmlEl = document.getElementsByTagName("html")[0];
    var mainNavItems = document.querySelectorAll("li.has-submenu");
    var ariaBtn = document.querySelectorAll("li.has-submenu button");
    var overlayContainer = document.querySelector(".dropdown-overlay");
    var mediaQueryUnderSearch = window.matchMedia('(max-width: 1023px)');
    searchTriggerBtn.addEventListener("click", function (e) {
      // Opens search menu
      if (!searchTriggerBtn.classList.contains('active-search')) {
        this.classList.add('active-search');
        this.setAttribute("aria-expanded", "true");
        addFocus();
        overlayContainer.classList.add('active-menu');
        if (mediaQueryUnderSearch.matches) {
          if (!htmlEl.classList.contains('mobile-open')) {
            htmlEl.classList.add('mobile-open');
          }
        }
        if (!mobileSearch.classList.contains('active-search')) {
          mobileSearch.classList.add('active-search');
        }
        if (!overlayContainer.classList.contains('active-menu')) {
          overlayContainer.classList.add('active-menu');
        }
      } else {
        this.classList.remove('active-search');
        this.setAttribute("aria-expanded", "false");
        if (mediaQueryUnderSearch.matches) {
          htmlEl.classList.remove('mobile-open');
        }
        mobileSearch.classList.remove('active-search');
        overlayContainer.classList.remove('active-menu');
      }

      // Closes open main nav menus
      mainNavItems.forEach(function (item) {
        if (item.classList.contains("open")) {
          item.classList.remove("open");
        }
      });

      // Resets aria on main nav
      ariaBtn.forEach(function (btn) {
        btn.setAttribute("aria-expanded", "false");
      });
      e.stopPropagation();
    });
    closeSearch.addEventListener("click", function (e) {
      searchTriggerBtn.classList.remove("active-search");
      mobileSearch.classList.remove("active-search");
      if (mediaQueryUnderSearch.matches) {
        htmlEl.classList.remove("mobile-open");
      }
      searchTriggerBtn.setAttribute("aria-expanded", "false");
      overlayContainer.classList.remove("active-menu");
    });
    function addFocus() {
      var inputContainer = document.querySelector('.magic-box-input input');
      //inputContainer.focus();
    }
  }
});